import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/evaluation-dashboard',
        component: () => import('@/pages/dashboards/evaluation-dashboard/EvaluationDashboard.vue'),
        props: true,
        name: 'evaluation-dashboard',
        meta: {
            title: 'Evaluation Dashboard',
            middleware: [GateKeeperMiddleware],
            ability: ({ gateKeeper, to }) =>
                gateKeeper.userHasPermission('view evaluation dashboard') ||
                gateKeeper.userIsGroupInstructor() ||
                (to.name === 'evaluation-instructor' &&
                    gateKeeper.userIsViewingOwnResource(to.params.userId) &&
                    gateKeeper.userIsInstructor()),
        },
        children: [
            {
                name: 'evaluation-instructors',
                path: '/evaluation-dashboard/instructors',
                component: () => import('@/components/evaluation-dashboard/EvaluationDashboardInstructorsView.vue'),
                meta: {
                    ability: ({ gateKeeper }) =>
                        gateKeeper.userHasPermission('view evaluation dashboard') || gateKeeper.userIsGroupInstructor(),
                },
            },
            {
                name: 'evaluation-instructor',
                path: '/evaluation-dashboard/instructor/:userId',
                component: () => import('@/components/evaluation-dashboard/EvaluationDashboardInstructorView.vue'),
                props: true,
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper, to }) =>
                        (gateKeeper.userIsViewingOwnResource(to.params.userId) && gateKeeper.userIsInstructor()) ||
                        gateKeeper.userHasPermission("view another user's evaluation dashboard") ||
                        gateKeeper.userIsGroupInstructor(),
                },
            },
        ],
    },
];
